import { jsx as n } from "react/jsx-runtime";
import { c as t } from "../clsx-OuTLNxxd.js";
import { c as m } from "../index-BwYCDOHZ.js";
const _ = "_isRound_12dx7_8", r = "_badge_12dx7_27", s = {
  "size-s": "_size-s_12dx7_1",
  isRound: _,
  "size-m": "_size-m_12dx7_13",
  badge: r
}, c = m(s.badge, {
  variants: {
    size: {
      s: s["size-s"],
      m: s["size-m"]
    },
    isRound: {
      true: s.isRound
    }
  },
  defaultVariants: {
    size: "m",
    isRound: !1
  }
}), g = ({
  children: a,
  className: e,
  isRound: i,
  size: o = "m",
  ...d
}) => /* @__PURE__ */ n(
  "span",
  {
    className: t(c({ size: o, isRound: i }), e),
    ...d,
    children: a
  }
);
export {
  g as Badge
};
